const DeliveryQueryKey = {
  DELIVERY: 'DELIVERY',
  DELIVERY_DETAIL: 'DELIVERY_DETAIL',
};

export default DeliveryQueryKey;
